module.exports = __webpack_public_path__ + "e37409ce5de274f2bc4b4d8c90773bb5.png";